import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Anchor, Target, Award, Ship, Zap, Quote } from 'lucide-react';
import { ShieldCheck, Gem, Compass, ArrowRight, CheckCircle2 } from 'lucide-react';
import {  MessageCircle, FileText } from "lucide-react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Eye,
  
  Users, 
} from "lucide-react";

export default function About() {
  const cards = [
  {
    title: "Vision",
    icon: Eye,
    content:
      "To make Indiaboats one of India’s most trusted names for safe, memorable and premium experiences on the water.",
  },
  {
    title: "Mission",
    icon: Target,
    content:
      "To create on-water experiences that combine strong safety standards, smooth execution and unforgettable guest moments across Mumbai and Goa.",
  },
  {
    title: "Our Team",
    icon: Users,
    content:
      "Behind every Indiaboats experience is a team that understands that hospitality on the water begins with responsibility. We are committed to helping guests feel comfortable, cared for and confident throughout the journey, whether they are celebrating, travelling or hosting an event.",
  },
];

    const brandColor = '#113d48'; 
  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
      <>
  {/* <div className="breadcumb-wrapper " style={{
    backgroundImage: "url(/assets/img/boat1.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}>
    <div className="container">
      <div className="breadcumb-content aboutus-text-bg">
        <h1 className="breadcumb-title">About India Boats</h1>
        <ul className="breadcumb-menu">
          <li>
            <a href="/">Home</a>
          </li>
          <li>About Tourm</li>
        </ul>
      </div>
    </div>
  </div> */}

  <section className="oshs-root">
      <div className="oshs-container">
        
        {/* Asymmetric Timeline and Mission Header */}
        <div className="oshs-grid">
          
          {/* Left Column: The Narrative Journey */}
          <div className="oshs-left-col">
            <span className="oshs-tag">Our Legacy</span>
            
            {/* Elegant watermark background element */}
            <div className="oshs-watermark">2016</div>
            
            <h1 className="oshs-main-title">Our Story</h1>
            <div className="oshs-divider"></div>
            
            <div className="oshs-narrative-stack">
              <p className="oshs-paragraph oshs-highlight-para">
                Indiaboats began in August 2016 with a simple but powerful belief — that time on the water should feel safe, seamless and unforgettable.
              </p>
              
              <p className="oshs-paragraph">
                What started as a passion-led idea has grown into a trusted platform for private yacht charters, speed boat transfers, celebrations, family outings and corporate experiences in Mumbai and Goa.
              </p>
              
              <p className="oshs-paragraph">
                Today, Indiaboats is proud to offer one of the largest yacht fleets in Mumbai and Goa, helping guests enjoy the water with more confidence, comfort and ease.
              </p>
            </div>
          </div>

          {/* Right Column: Premium Mission Statement Framing */}
          <div className="oshs-right-col">
            <div className="oshs-quote-card">
              {/* Top Accent Compass Icon */}
              <div className="oshs-compass-box">
                <svg className="oshs-compass-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="22" stroke="#113d48" strokeWidth="1.5" strokeDasharray="4 2"/>
                  <circle cx="32" cy="32" r="28" stroke="rgba(17,61,72,0.15)" strokeWidth="1"/>
                  <path d="M32 12L35 29L52 32L35 35L32 52L29 35L12 32L29 29Z" fill="#113d48"/>
                  <circle cx="32" cy="32" r="3" fill="#ffffff"/>
                </svg>
              </div>

              {/* The Core Purpose Text Block */}
              <blockquote className="oshs-quote-text">
                "At its heart, Indiaboats was never meant to be just about boats. It was created to deliver better experiences on the water."
              </blockquote>
              
              {/* Delicate Maritime Signature line */}
              <div className="oshs-quote-signature">
                <span className="oshs-sig-line"></span>
                <span className="oshs-sig-name">The Indiaboats Promise</span>
              </div>
            </div>
          </div>

        </div>

      </div>
      </section>

     <section className="ib-fj-section-wrapper">
  <div className="ib-fj-container">
    {/* Unified Section Header */}
    <div className="ib-fj-header">
      <span className="ib-fj-subtitle">The Founder’s Journey</span>
      <h2 className="ib-fj-title">
        Indiaboats was founded by Mehul Ashar, whose life has been shaped by the
        sea.
      </h2>
      <hr className="ib-fj-divider" />
    </div>
    {/* Layout Grid */}
    <div className="ib-fj-grid">
      {/* Left Column: Portrait & Visuals */}
      <div className="ib-fj-image-col">
        <div className="ib-fj-image-frame-container">
          <div className="ib-fj-image-wrapper">
            {/* Replace this elegant placeholder URL with the actual portrait of Mehul Ashar */}
            <img
              src="assets/img/Mehul_Ashar.jpeg"
              alt="Mehul Ashar - Founder of Indiaboats"
              className="ib-fj-img"
              onerror="this.src='https://placehold.co/600x750/113d48/ffffff?text=Founder+Portrait'"
            />
            <div className="ib-fj-image-badge">National Champion</div>
          </div>
        </div>
        <p className="ib-fj-image-caption">
          Mehul Ashar, decorated yachtsman and founder of Indiaboats, bringing
          elite-level marine expertise to private charter experiences.
        </p>
      </div>
      {/* Right Column: Narrative Content & Core Quote */}
      <div className="ib-fj-content-col">
        <div className="ib-fj-paragraphs-wrapper">
          <p className="ib-fj-paragraph ib-fj-paragraph-lead">
            With over 35 years of sailing experience, Mehul built an
            extraordinary journey in the sport, becoming a decorated national
            sailing champion and representing India at prestigious Asian sailing
            regattas and World Championships over multiple years.
          </p>
          <p className="ib-fj-paragraph">
            Years of racing taught him lessons that go far beyond competition —
            discipline, awareness, preparation, teamwork and deep respect for
            the water. Those lessons became the foundation of Indiaboats.
          </p>
          <p className="ib-fj-paragraph">
            The vision was clear: to bring the same standards of confidence,
            care and excellence from competitive sailing into every guest
            experience, so that every charter, celebration, transfer or
            corporate event feels not only special, but also safe and
            professionally handled.
          </p>
        </div>
        {/* Styled Quote Callout */}
        <div className="ib-fj-quote-card">
          {/* Marine Compass Vector Art Detail */}
          <div className="ib-fj-quote-svg-bg">
            <svg
              viewBox="0 0 100 100"
              fill="none"
              stroke="currentColor"
              strokeWidth={1}
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx={50} cy={50} r={46} strokeDasharray="2 3" />
              <circle cx={50} cy={50} r={41} strokeWidth="0.75" />
              <circle cx={50} cy={50} r={3} fill="currentColor" />
              <path d="M50 4 L50 96 M4 50 L96 50" strokeWidth="0.5" />
              <path
                d="M50 12 L54 46 L88 50 L54 54 L50 88 L46 54 L12 50 L46 46 Z"
                fill="currentColor"
                fillOpacity="0.1"
              />
              <path
                d="M25 25 L75 75 M25 75 L75 25"
                strokeWidth="0.5"
                strokeDasharray="1 3"
              />
            </svg>
          </div>
          <span className="ib-fj-quote-icon">“</span>
          <blockquote className="ib-fj-quote-text">
            “Years of racing taught me that the sea rewards preparation,
            discipline and respect. That is exactly what every guest deserves
            today — not just a beautiful experience on the water, but one that
            feels safe, seamless and truly memorable.”
          </blockquote>
          <div className="ib-fj-quote-author-wrapper">
            <span className="ib-fj-author-line" />
            <div>
              <cite className="ib-fj-quote-author">Mehul Ashar</cite>
              <span className="ib-fj-quote-role">Founder, Indiaboats</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

 <section className="ib-wsf-section-wrapper">
   <div className="ib-wsf-container">
        
        {}
        {/* Scopes Center-Aligned Title */}
        <div className="ib-wsf-header-block">
          <span className="ib-wsf-sub">What We Stand For</span>
          <h2 className="ib-wsf-heading">
            At Indiaboats, two dynamic standards govern everything we build.
          </h2>
          <hr className="ib-wsf-divider" />
          <p className="ib-wsf-intro-text">
            We believe a premium experience on the water should never feel uncertain or poorly managed. It should feel smooth, comfortable, exciting, and professionally coordinated from the first enquiry to the final moment of your journey.
          </p>
        </div>

        {}
        {/* Central "Dual-Pillar" Core Highlight Feature */}
        <div className="ib-wsf-pillars-showcase">
          
          {}
          <div className="ib-wsf-pillar-item">
            <div className="ib-wsf-pillar-image-container">
              <img 
                src="assets/img/about2.png" 
                alt="Guest Safety Onboard" 
                className="ib-wsf-pillar-image"
              />
            </div>
            <span className="ib-wsf-pillar-badge">Priority One</span>
            <h3 className="ib-wsf-pillar-title">Guest Safety</h3>
            <p className="ib-wsf-pillar-tagline">
              Uncompromising standards, certified operations, and thorough marine risk mitigation.
            </p>
          </div>

          <div className="ib-wsf-pillar-connector">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>

          {}
          <div className="ib-wsf-pillar-item">
            <div className="ib-wsf-pillar-image-container">
              <img 
                src="assets/img/about1.png" 
                alt="Premium Yacht Experience" 
                className="ib-wsf-pillar-image"
              />
            </div>
            <span className="ib-wsf-pillar-badge">Priority Two</span>
            <h3 className="ib-wsf-pillar-title">Guest Experience</h3>
            <p className="ib-wsf-pillar-tagline">
              Flawless hospitality, bespoke design details, and smooth, scenic navigation.
            </p>
          </div>

        </div>

        {/* Symmetrical Balanced Commitment Cards */}
        <div className="ib-wsf-grid">
          
          {/* Card 1 - Top Row */}
          <div className="ib-wsf-card ib-wsf-card-row-top">
            <div className="ib-wsf-card-top-row">
              <div className="ib-wsf-card-icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  <path d="m9 12 2 2 4-4"/>
                </svg>
              </div>
              
            </div>
            <h4 className="ib-wsf-card-title">Guest safety and responsible operations</h4>
            <p className="ib-wsf-card-desc">
              Strict adherence to marine regulations, constant equipment inspections, and weather monitoring guidelines to secure absolute peace of mind.
            </p>
          </div>

          {/* Card 2 - Top Row */}
          <div className="ib-wsf-card ib-wsf-card-row-top">
            <div className="ib-wsf-card-top-row">
              <div className="ib-wsf-card-icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              
            </div>
            <h4 className="ib-wsf-card-title">Trained crew and smooth coordination</h4>
            <p className="ib-wsf-card-desc">
              Highly certified skippers, engineers, and hospitality hosts operating under optimized communication channels to handle all logistics behind the scenes.
            </p>
          </div>

          {/* Card 3 - Top Row */}
          <div className="ib-wsf-card ib-wsf-card-row-top">
            <div className="ib-wsf-card-top-row">
              <div className="ib-wsf-card-icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 17h20l-1-4H3l-1 4z" />
                  <path d="M12 13V5l5 3-5 5z" />
                  <path d="M5 17c0 2 3.5 3 7 3s7-1 7-3" />
                </svg>
              </div>
              
            </div>
            <h4 className="ib-wsf-card-title">Choosing the right boat for the occasion</h4>
            <p className="ib-wsf-card-desc">
              A tailored fleet selection process matches size, luxury tiers, capabilities, and amenities perfectly to your dynamic party size or corporate agenda.
            </p>
          </div>

          {/* Card 4 - Bottom Row (Centered on Desktop) */}
          <div className="ib-wsf-card ib-wsf-card-row-bottom">
            <div className="ib-wsf-card-top-row">
              <div className="ib-wsf-card-icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  <path d="M8 10h.01M12 10h.01M16 10h.01" />
                </svg>
              </div>
              
            </div>
            <h4 className="ib-wsf-card-title">Comfort, clarity and customer support</h4>
            <p className="ib-wsf-card-desc">
              Transparent pricing frameworks and dedicated charter advisors assisting you step-by-step from booking itineraries to disembarkation.
            </p>
          </div>

          {/* Card 5 - Bottom Row (Centered on Desktop) */}
          <div className="ib-wsf-card ib-wsf-card-row-bottom">
            <div className="ib-wsf-card-top-row">
              <div className="ib-wsf-card-icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </div>
              
            </div>
            <h4 className="ib-wsf-card-title">Creating moments that feel scenic, memorable and special</h4>
            <p className="ib-wsf-card-desc">
              Intentional route mapping, curated photography spots, and bespoke custom additions designed to translate sailings into lifetime memories.
            </p>
          </div>

        </div>

      </div>
    
 </section>

 <section className="ibvmt-section">
      <div className="ibvmt-container">
        <div className="ibvmt-heading-wrap">
          <span className="ibvmt-subtitle">Who We Are</span>

          <h2 className="ibvmt-title">
            Vision, Mission <span>& Team</span>
          </h2>

          <p className="ibvmt-description">
            Every experience we create is driven by our commitment to
            hospitality, safety and unforgettable moments on the water.
          </p>
        </div>

        <div className="ibvmt-grid">
          {cards.map((item, index) => (
            <article className="ibvmt-card" key={index}>
              <div className="ibvmt-card-top">
                <div className="ibvmt-card-icon">
  <item.icon size={28} strokeWidth={2} />
</div>  

                <div className="ibvmt-divider"></div>
              </div>

              <h3>{item.title}</h3>

              <p>{item.content}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  
  <section className="ibcta-section">
      <div className="ibcta-container">
        <div className="ibcta-card">
          <div className="ibcta-badge">
            Ready to Set Sail?
          </div>

          <h2 className="ibcta-title">
            Experience the Water <span>with Confidence</span>
          </h2>

          <p className="ibcta-description">
            Whether you are planning a private yacht charter, a celebration,
            a speed boat transfer or a corporate event, Indiaboats is built to
            deliver experiences that feel safe, smooth and truly memorable.
          </p>

          <div className="ibcta-buttons">
            <a href="/" className="ibcta-btn ibcta-btn-primary">
              <Compass size={20} />
              Explore Experiences
            </a>

            <a
              href="https://wa.me/918591983301"
              className="ibcta-btn ibcta-btn-secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MessageCircle size={20} />
              Enquire on WhatsApp
            </a>

            <a href="/contact" className="ibcta-btn ibcta-btn-outline">
              <FileText size={20} />
              Request a Quote
            </a>
          </div>
        </div>
      </div>
    </section>   
   

</>

      <Footer />
    </>
  );
}
